import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
// import {  FirebaseListObservable } from 'angularfire2/database-deprecated';
// import { FirebaseObjectObservable } from 'angularfire2/database-deprecated';
import { 
  AngularFirestore 
} from 'angularfire2/firestore';
@Injectable({
  providedIn: 'root'
})
export class SearchService {

  searchy:any=[];
  ret;
  constructor(private db:AngularFirestore ) {

  //   var docRef = db.collection("adminlogin").doc("ret");

  //   docRef.ref.get().then((doc)=> {
  //       if (doc.exists) {
    
  //         this.ret=doc.data().ret;
  //           console.log("Document data:", doc.data().ret);
  //       } else {
  //           // doc.data() will be undefined in this case
  //           console.log("No such document!");
  //       }
  //   }).catch(function(error) {
  //       console.log("Error getting document:", error);
  //   });

   }
   
}
